"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalContract = void 0;
const contract_1 = require("../contract");
class ExternalContract extends contract_1.Contract {
    get address() {
        return this.services.networkService.getExternalContractAddress(this.name);
    }
}
exports.ExternalContract = ExternalContract;
